export default __webpack_public_path__ + "static/media/bookbg.bb914cf4.jpg";